import PropTypes from 'prop-types';
import { Flex, Modal as ModalMantine } from '@mantine/core';
import styles from './styles.module.css';

const Modal = (props) => {
  const {
    opened,
    onClose,
    actions,
    label,
    message,
    withCloseButton = false,
    labelIcon,
    variant = 'default',
  } = props;

  return (
    <ModalMantine.Root
      opened={opened}
      onClose={onClose}
      centered
      padding='2rem'
      radius='md'
      classNames={{ root: styles.modal, header: styles.header }}
      closeOnClickOutside={false}
    >
      <ModalMantine.Overlay />
      <ModalMantine.Content>
        {withCloseButton && <ModalMantine.Header>
            <ModalMantine.CloseButton />
          </ModalMantine.Header>
        }

        <ModalMantine.Body>
          <Flex align="center" justify={'center'}>
            {labelIcon && <div className={styles.labelIcon}>{labelIcon}</div>}
            <div className={variant === 'error' ? styles.labelError : styles.label}>{label}</div>
          </Flex>
          {message && <div className={styles.message}>{message}</div>}
          <div className={styles.actions}>
            {Array.isArray(actions) ? (
              <Flex gap="sm">
                {actions.map((action, index) => (
                  <div key={index}>{action}</div>
                ))}
              </Flex>
            ) : (
              actions
            )}
          </div>
        </ModalMantine.Body>
      </ModalMantine.Content>
    </ModalMantine.Root>
  );
};
Modal.propTypes = {
  opened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  label: PropTypes.string,
  actions: PropTypes.node,
  withCloseButton: PropTypes.bool,
  message: PropTypes.string,
  labelIcon: PropTypes.node,
  variant: PropTypes.string,
};

export default Modal;
